import React, { Component, useContext } from "react";
import ContentLoader from "react-content-loader";
import ReactModal from "react-modal";
import GoogleMapsMarkerColorEnum from "../../../models/Google Maps/GoogleMapsMarkerColorEnum";
import GoogleMapsMarkerSizeEnum from "../../../models/Google Maps/GoogleMapsMarkerSizeEnum";
import IAddress from "../../../models/IAddress";
import "./OwGoogleStaticMap.scss";
import INewAddress from "../../../models/INewAddress";
import UiContext from "@contexts/UiContext";
import HelperService from "@services/HelperService";
import { useGoogleMaps } from "@hooks/shared/useGoogleMaps";
import { OwGoogleZoomedStaticMap } from "../OwGoogleZoomedStaticMap/OwGoogleZoomedStaticMap";

type Props = {
    address: IAddress | INewAddress;
    size?: string;
    zoomLevel?: number;
    markerSize?: GoogleMapsMarkerSizeEnum;
    markerColor?: GoogleMapsMarkerColorEnum | string; // string should be in the Format 'FFFF00'
    className?: string;
};

const OwGoogleStaticMap = (props: Props) => {
    const uiContext = useContext(UiContext);
    const googleMaps = useGoogleMaps({
        markerSize: props.markerSize,
        markerColor: props.markerColor,
        zoomLevel: props.zoomLevel,
        size: props.size,
    });

    const [zoomedMapSource, setZoomedMapSource] = React.useState<string | null>(null);
    const [imageLoaded, setImageLoaded] = React.useState<boolean>(false);

    const afterOpenModal = () => {
        // this.setState({
        //     zoomedMapSource: this.getZoomedMapSource(),
        // });
    };

    const closeModal = () => {
        // this.setState({ modalIsOpen: false });
    };

    const openModal = () => {
        uiContext.setModalCloseOnEsc(true);
        uiContext.setModalCloseOnOverlayClick(true);

        uiContext.setModalComponent(<OwGoogleZoomedStaticMap address={props.address} />);

        uiContext.showModal(true);

        // uiContext.
        // this.setState({
        //     modalIsOpen: true,
        // });
    };

    const imageLoadedFn = () => {
        setImageLoaded(true);
    };

    if (!props.address) {
        return null;
    }

    const encodedAddress = googleMaps.getEncodedAddress(props.address);
    const zoomLevel = googleMaps.getZoomLevel();
    const size = googleMaps.getSize();
    const markerSize = googleMaps.getMarkerSize();
    const markerColor = googleMaps.getMarkerColor();
    const apiKey = googleMaps.getGoogleMapsAPIKey();

    const imageSize = googleMaps.getImageSize();

    const parameters = `center=${encodedAddress}&zoom=${zoomLevel}&size=${size}&markers=${markerSize}${markerColor}${encodedAddress}&maptype=roadmap&key=${apiKey}`;

    const googleMapsSource = `https://maps.googleapis.com/maps/api/staticmap?${parameters}`;

    const modalStyle = {};

    return (
        <div className={"OwGoogleStaticMap " + props.className}>
            <div className={"mapWrapper"} style={{ width: `${imageSize.width + 2}px`, height: `${imageSize.height + 2}px` }}>
                <div className={"hover-overlay align-items-center justify-content-center"} onClick={openModal}>
                    <i className={"fad fa-2x fa-search-plus"} />
                </div>
                {imageLoaded ? null : (
                    <ContentLoader
                        speed={2}
                        backgroundColor="#343434"
                        foregroundColor="#44464a"
                        width={imageSize.width || 120}
                        height={imageSize.height || 120}
                        viewBox={`0 0 ${imageSize.width || 120} ${imageSize.height || 120}`}
                        style={{ width: "100%" }}>
                        <rect x="0" y="0" width={imageSize.width || 120} height={imageSize.height || 120} />
                    </ContentLoader>
                )}

                <img
                    alt={"Google Map"}
                    src={googleMapsSource}
                    className={"border border-dark rounded"}
                    onLoad={() => {
                        imageLoadedFn();
                    }}
                />
            </div>

            {/* <ReactModal
                id={"reactModal"}
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                contentLabel="Google Map"
                style={modalStyle}
                className={"modalClass"}
                overlayClassName={"overlayClass"}
                ariaHideApp={true}>
                {this.state.zoomedMapSource ? (
                    <div className={"d-flex justify-content-center align-items-center"}>
                        <img alt={"Zoomed Google Map"} src={this.state.zoomedMapSource} className={"border border-dark rounded"} />
                    </div>
                ) : null}
            </ReactModal> */}
        </div>
    );
};

export default OwGoogleStaticMap;
